module.exports = __webpack_public_path__ + "static/media/notice.5fe5a001.jpeg";